export const WEEK_KO = ['일', '월', '화', '수', '목', '금', '토'] as const;
export const WEEK_EN = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'] as const;
